var _polygon, _line, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icone",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fc0",
    points: "271.13 230.8 331.35 106 222.39 106 194.12 287.22 246.47 287.22 240.99 307.22 266.47 307.22 247.07 377.98 328.24 250.8 291.13 250.8 300.79 230.8 271.13 230.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    x1: 181.48,
    x2: 181.33,
    y1: 220.01,
    y2: 221.01
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: "177.47 245.72 171 287.22 246.47 287.22 202.38 448 341 230.8 271.13 230.8 341 86 202.38 86 185.34 195.3",
    stroke: "#02005c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.7e7f6ee024439a62e3c1c2e089cbdce3.svg";
export { ForwardRef as ReactComponent };